module.exports = __webpack_public_path__ + "img/聂庆宇.72801da9.jpg";